require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-dkc-9-w.json") })
        }
      }, "path---photos-professional-dkc-9-w");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-dkc-9-w!./.cache/json/photos-professional-dkc-9-w.json
// module id = 731
// module chunks = 231608221292675